export default __webpack_public_path__ + "static/media/sliderClose.16dc8849.svg";